import { h } from '@stencil/core';
import { apiArgs } from './api-helpers';

// TODO: refatorar stories para usar esse StoreStoryTemp ao inves do StoreStory
// export function StoreStory(args, content, options?: { noAuth?: boolean; initialState?: any }) {
export function StoreStory(props:{noAuth?: boolean,initialState?: any, [k: string]: any}, children) {
  const storeContent = props?.noAuth ? children : <sy-one-auth-slot>{children}</sy-one-auth-slot>;
  const initialState = props?.initialState || DEFAULT_INITIAL_STATE;

  return (
    <sy-one-api {...apiArgs(props)}>
      <sy-one-store
        ref={ref => {
          if (ref && initialState) {
            ref.initialState = initialState;
          }
        }}
      >
        {storeContent}
      </sy-one-store>
    </sy-one-api>
  );
}



const DEFAULT_INITIAL_STATE = {
  env: {
    currentLanguage: 'pt',
    organizationConfigs: {
      supportedLanguages: [
        {
          code: 'pt',
          name: 'Português',
        },
        {
          code: 'en',
          name: 'English',
        },
        {
          code: 'es',
          name: 'Español',
        },
      ],
    },
  },
};
